// Mezcla de colores para derivar variantes de la paleta del tenant en los PDFs.
// Puras, sin dependencias: el motor de PDF no puede usar CSS color-mix().

const HEX = /^#([0-9a-f]{6})$/i;

const parse = (hex) => {
  const m = typeof hex === 'string' && hex.match(HEX);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

const toHex = (rgb) =>
  '#' +
  rgb
    .map((v) =>
      Math.max(0, Math.min(255, Math.round(v)))
        .toString(16)
        .padStart(2, '0')
    )
    .join('');

// Oscurece hacia negro. factor 1 = igual, 0 = negro.
export const shade = (hex, factor) => {
  const rgb = parse(hex);
  if (!rgb) return hex;
  return toHex(rgb.map((v) => v * factor));
};

// Aclara hacia blanco. amount 0 = igual, 1 = blanco.
export const tint = (hex, amount) => {
  const rgb = parse(hex);
  if (!rgb) return hex;
  return toHex(rgb.map((v) => v + (255 - v) * amount));
};
